<!-- eslint-disable import/no-cycle -->
<template>
  <section>
    <b-card>
      <h1>Statistiques sur les établissements d'hébergement de voyageurs</h1>
      <div class="mt-2">
        <h3>Filtres de recherche</h3>
        <StatisticsFilters
          v-model="filtersForm"
          :active-filters="activeFilters"
          :is-loading="isLoadingTableData"
          @submit="getStatistics"
        />

      </div>
    </b-card>

    <b-row class="match-height">
      <!-- <b-col lg="6">
        <StatsEtablissementParService />
      </b-col> -->

      <b-col
        v-if="false"
        lg="12"
      >
        <StatsEtablissementParType />
      </b-col>
      <!-- <b-col

        lg="12"
      >
        <NombreEtablissementParTypeParLocalisation  :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"/>
      </b-col> -->
      <b-col
        lg="12"
      >
        <NombreEtablissementParTypeParLocalisation
          :table-datas="statsData.nombreEtabHebergementPerLocation.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col
        v-if="statsData.statsFichesMensuellesHotels && statsData.statsFichesMensuellesHotels.statsEtabParClassement"
        lg="12"
      >
        <NombreEtablissementParClassement
          :stats-datas="statsData.statsFichesMensuellesHotels.statsEtabParClassement"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col lg="12">
        <NombreTotalNuiteeParLocalisation
          :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col lg="12">
        <NombreMoyenNuiteeParLocalisation
          :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>
      <b-col lg="12">
        <NombreArriveesParLocalisation
          :table-datas="statsData.clientHotel.tableDatas"
          :is-loading-table-data="isLoadingTableData"
        />
      </b-col>

    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardTitle,
  BDropdown,
  BDropdownItem,
  BCardBody,
  BCardText,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { $themeColors } from '@themeConfig'
import utilsService from '@/services/utils/utils.service'
import StatisticsFilters from '@/components/StatisticsFilters.vue'

// store modules and vuex utilities
// eslint-disable-next-line import/no-cycle
import etablissementsStroreModule from '@/store/etablissements'
// eslint-disable-next-line import/no-cycle
import paramsStoreModule from '@/store/params'
// eslint-disable-next-line import/no-cycle
import statisticsStoreModule from '@/store/statistics'
// eslint-disable-next-line import/no-cycle
import formulaireStoreModule from '@/store/formulaire'

// eslint-disable-next-line import/no-cycle
import {
  registerStoreModule,
  unregisterStoreModule,
} from '@/helpers/vuex-utils'
import { mapActions, mapState } from 'vuex'
import { buildFiltersForRequest } from '@/helpers/http-utils'
import NombreTotalNuiteeParLocalisation from './NombreTotalNuiteeParLocalisation.vue'
import NombreMoyenNuiteeParLocalisation from './NombreMoyenNuiteeParLocalisation.vue'
import NombreArriveesParLocalisation from './NombreArriveesParLocalisation.vue'

import NombreEtablissementParClassement from './NombreEtablissementParClassement.vue'
import NombreEtablissementParTypeParLocalisation from './NombreEtablissementParTypeParLocalisation.vue'

import StatsEtablissementParType from './StatsEtablissementParType.vue'
import StatsPaysVoyageurs from './StatsPaysVoyageurs.vue'
import StatsCategorieSocioPro from './StatsNombreMoyenTransport.vue'

const activeFilters = [
  'periode',
  'trancheAge',
  'sexe',
  'lieuResidence',
  'categorieSocioProfessionnelle',
  'modeTransportInterieurBenin',
]

const statsData = {
  clientHotel: {
    tableDatas: {
      departements: [],
      communes: [],
      arrondissements: [],
      villages: [],
    },
  },
  nombreEtabHebergementPerLocation: {
    tableDatas: {
      departements: [],
      communes: [],
      arrondissements: [],
      villages: [],
    },
  },
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardBody,
    BCardText,
    StatisticsFilters,
    BButton,
    BSpinner,
    StatsCategorieSocioPro,
    StatsPaysVoyageurs,
    StatsEtablissementParType,
    NombreTotalNuiteeParLocalisation,
    NombreMoyenNuiteeParLocalisation,
    NombreArriveesParLocalisation,
    NombreEtablissementParClassement,
    NombreEtablissementParTypeParLocalisation,
  },
  setup() {
    const requiredStoreModules = [
      { path: 'etablissements', module: etablissementsStroreModule },
      { path: 'params', module: paramsStoreModule },
      { path: 'statistics', module: statisticsStoreModule },
      { path: 'formulaire', module: formulaireStoreModule },

    ]

    // Register module
    registerStoreModule(requiredStoreModules)

    return { requiredStoreModules }
  },
  data() {
    return {
      isLoadingTableData: false,

      isLoading: false,
      activeFilters,
      filtersForm: {},

      statsData,

    }
  },
  computed: {
    etablissementId() {
      return utilsService.etablissementId
    },
  },
  beforeDestroy() {
    unregisterStoreModule(this.requiredStoreModules)
  },
  async mounted() {
    await this.getStatistics()
  },
  methods: {
    ...mapActions('statistics', {
      action_getStatisticsAgencesVoyageToursOperators:
        'getStatisticsAgencesVoyageToursOperators',
      action_getStatsEtablissementsHebergement: 'getStatsEtablissementsHebergement',
      action_getStatisticsTransport: 'getStatisticsTransport',
    }),
    ...mapActions('formulaire', {
      fetchFormulaires: 'fetchFormulaires',
      exportFormulaires: 'exportFormulaires',
    }),
    ...mapActions('etablissements', {
      action_getListTypesEtablissement: 'getListTypesEtablissement',
    }),
    onPaginationChange(val) {
      // console.log('paginationChange', val)
      this.paginationData = { ...this.paginationData, ...val }
    },
    localFilter() {
      const query = this.localSearchQuery.toLowerCase()
      this.filteredTableDatas[this.selectedTypeLocalisation] = this.tableDatas[
        this.selectedTypeLocalisation
      ].filter(e => {
        if (!query) return true
        return e.name.toLowerCase().includes(query)
      })
      this.filteredTableDatas[this.selectedTypeLocalisation] = this.filteredTableDatas[this.selectedTypeLocalisation].filter(e => true)
    },
    async getStatistics() {
      this.isLoadingTableData = true

      // console.log('this.filtersForm :>> ', this.filtersForm)
      const periodeFilter = () => {
        const { from, to } = this.filtersForm.periode || {}
        if (!from && !to) return { createdAt: '' }
        const result = !to ? `${from},${from}` : `${from},${to}`
        return { createdAt: result }
      }
      const trancheAgeFilter = () => {
        const { min, max } = this.filtersForm.trancheAge || {}
        if (!min && !max) return { age: '' }
        const result = !max ? `${min},${min}` : `${min},${max}`
        return { age: result }
      }

      const filters = {
        ...this.filtersForm,
        ...periodeFilter(),
        ...trancheAgeFilter(),
        modeTransportInterieurBenin: (this.filtersForm.modeTransportInterieurBenin || []).join(','),
        categorieSocioPro: (this.filtersForm.categorieSocioProfessionnelle || []).join('.'),
        sexe: (this.filtersForm.sexe || []).join(','),

      }

      delete filters.periode
      delete filters.categorieSocioProfessionnelle
      delete filters.trancheAge
      // console.log('filters :>> ', filters)
      const processedFilters = buildFiltersForRequest(filters)
      // console.log('processedFilters :>> ', processedFilters)
      const reqOptions = {
        params: {
          filter: processedFilters,
        },
      }
      await this.action_getStatsEtablissementsHebergement(reqOptions)
        .then(async res => {
          // console.log('res', res)

          // await this.getListTypesEtablissement()
          // const { data } = res
          // const { resources } = data
          // const { options } = resources
          const { statsFichesClientes, statsFichesMensuellesHotels, nombreEtabHebergementPerLocation } = res || {}
          // console.log('statsFichesMensuellesHotels :>> ', statsFichesMensuellesHotels)

          this.statsData.statsFichesMensuellesHotels = statsFichesMensuellesHotels

          const { tableDatas: clientHotelTableDatas } = this.statsData.clientHotel
          statsFichesClientes.forEach(localisationItem => {
            const { items, queryId: localisation } = localisationItem
            clientHotelTableDatas[`${localisation}s`] = items
          })

          const { tableDatas: nombreEtabHebergementPerLocationTableDatas } = this.statsData.nombreEtabHebergementPerLocation
          nombreEtabHebergementPerLocation.forEach(localisationItem => {
            const { items, queryId: localisation } = localisationItem
            nombreEtabHebergementPerLocationTableDatas[`${localisation}s`] = items
          })

          this.statsData.clientHotel.tableDatas = clientHotelTableDatas

          this.isLoadingTableData = false

          // console.log('stats', res)
        })
        .catch(error => {
          this.isLoadingTableData = false

          // console.log(error)
        })
    },

  },
  created() {},
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
